import { Container, Row, View } from "@amzn/stencil-react-components/layout";
import { PageMainContainer } from "@amzn/it-shop-shared-components";
import { IItemVersion, ItemDetails } from "@/common/types/item.types";
import { ProductImage } from "@/common/components/ProductImage/product-image";
import { ProductOverview } from "@/pages/hardware-details/components/ProductOverview/product-overview";
import { OrderPanel } from "@/pages/hardware-details/components/OrderPanel/order-panel";
import React from "react";

export interface ProductDetailsSectionProps {
  item: ItemDetails;
  parentItemName: string;
  priceAmount: number;
  priceCurrency: string;
  versions: IItemVersion[];
  defaultVersion: IItemVersion | undefined;
  updateVersionSelected: (version: IItemVersion) => void;
}

export const ProductDetailsSection: React.FC<ProductDetailsSectionProps> = ({
  item,
  parentItemName,
  priceAmount,
  priceCurrency,
  versions,
  defaultVersion,
  updateVersionSelected,
}) => {
  return (
    <PageMainContainer className="product-details" paddingBottom="S500">
      <View>
        <Container paddingBottom="S300" paddingTop="S300" />
        <Row gridGap="S700" alignItems="flex-start" className="product-description-box">
          <ProductImage logoUrl={item.logoUrl} altText={`${item.name} logo`} size={160} className="pdp-column-left" />
          <ProductOverview
            parentItemName={parentItemName}
            shortDescription={item.shortDescription}
            categories={item.categories}
            os={item.os}
            dataClassification={item.dataClassification}
            securityStatus={item.securityStatus}
            version={item.version}
          />
          <OrderPanel
            priceAmount={priceAmount}
            priceCurrency={priceCurrency}
            versions={versions}
            defaultVersion={defaultVersion}
            updateVersionSelected={updateVersionSelected}
            parentName={item.parentName}
            parentTxId={item.parentTxId}
          />
        </Row>
      </View>
    </PageMainContainer>
  );
};
